import { type FC } from 'react';
import { UiIconCircle } from '../../lib/ui/Icon/UiIconCircle';
import { UiIconCheckCircle } from '../../lib/ui/Icon/UiIconCheckCircle';

export const UiIconCheckBoxCircle: FC<{ value: boolean }> = (props) => {
  return (props.value
    ? (<UiIconCheckCircle color={'primary.500'} size={'3xl'} />)
    : (<UiIconCircle color={'gray.500'} size={'3xl'} />));
};
